import { Component, Input, input, model, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { toObservable } from '@angular/core/rxjs-interop';
import { isEmpty, map } from 'rxjs';
import { ConfigService } from '../../../app-config.service';

@Component({
  selector: 'bi-left-menu',
  templateUrl: './left-menu.component.html',
  styleUrl: './left-menu.component.scss',
  standalone: false
})
export class LeftMenuComponent {
  activeSection = model<any>();
  sectionClick = output<any>();

  sections = model<any[]>([]);
  @Input() selectedTab!: string;
  thDomain!: string;
  constructor(private _configService: ConfigService) {
    let currentUserData = localStorage.getItem('currentBIUser') ? JSON.parse(localStorage.getItem('currentBIUser')!) : {};
    this.thDomain = currentUserData?.source_url ? currentUserData.source_url : this._configService.get('platform').thDomain;
    // Add https: if not found
    if (this.thDomain && !this.thDomain.startsWith('http://') && !this.thDomain.startsWith('https://')) {
      this.thDomain = 'https://' + this.thDomain;
    }
  }
  
  // Convert signal to observable and check if array is empty
  isSectionsEmpty$ = toObservable(this.sections).pipe(
    map(sections => sections.length === 0)
  );

  /**
   * this method is used to click the active module
   * @param section 
   * @author chari on 05/28/2025
   */
  onSectionClick(section: any) {
    this.activeSection.set(section?.id);
    this.sectionClick.emit(section);
  }
}
